module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8011.5d467ede.png";